//TABLE OF CONTENTS 

import React from 'react'
import Header from './Header'
import "../styles/tableOfContents.css"



export default function TableOfContents(props) {
    
//    need to add event here for expanding anchor content 
    
    
    return(
        
        <div class={props.testClass}>
        
            <div class='row'>
        
                {props.data.map((table_of_contents) => 
    
                    <div class={props.elementClass} id={props.gridId}>
                                    
                        <img class={props.iconClass} src={table_of_contents.icon}></img>  
                                    
                        <p class="contentsHeader"><a href={table_of_contents.url}>{table_of_contents.menu_option}</a></p>     
    
                    </div>
    
                )}
        
            </div>
            
        </div>
        
    );
    
}